module.exports = __webpack_public_path__ + "static/media/curIndiRedaccion.23f8c1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curIndiRedaccion.png
// module id = 974
// module chunks = 0